/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramGeoDetectControllerGetLocationQueryResponse } from '../types/TelegramGeoDetectControllerGetLocation.ts';

function getTelegramGeoDetectGetLocationUrl() {
  const res = { method: 'GET', url: `/api/telegram/geo-detect` as const };
  return res;
}

/**
 * {@link /api/telegram/geo-detect}
 */
export async function telegramGeoDetectGetLocation(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramGeoDetectControllerGetLocationQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramGeoDetectGetLocationUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
